if (!customElements.get('row-teaser')) {
  class RowTeaser extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.handleResize = this.onResize.bind(this);
      this.resizeTimeout = null;
      this.isLocked = null; // Track lock state
    }

    connectedCallback() {
      this.container = this.querySelector('[data-swiper-el]');
      this.wrapper = this.querySelector('[data-swiper-wrapper]');
      this.slides = this.querySelectorAll('[data-swiper-slide]');
      this.buttonGroup = this.querySelector('[data-swiper-button-group]');
      this.prevEl = this.querySelector('[data-swiper-prev]');
      this.nextEl = this.querySelector('[data-swiper-next]');

      this.isSwiperEnabled = this.container?.hasAttribute('data-swiper-enabled');

      if (this.isSwiperEnabled) {
        this.enableSwiper(true); // force first run
      }

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroySwiper();
    }

    enableSwiper(force = false) {
      // Check lock state if not forcing a full refresh
      if (!force && this.swiperInstance) {
        const prevLocked = this.isLocked;
        this.swiperInstance.update();
        const newLocked = this.swiperInstance.isLocked;

        // Only continue if lock state changed (e.g., slides now overflow or not)
        if (prevLocked === newLocked) return;

        this.isLocked = newLocked;
        this.buttonGroup?.classList.toggle('hidden', newLocked);
        return;
      }

      this.destroySwiper();
      this.addSwiperClasses();
      this.initSwiper();
    }

    addSwiperClasses() {
      if (!this.container || !this.wrapper || !this.slides.length) return;
      this.container.classList.add('swiper');
      this.wrapper.classList.add('swiper-wrapper');
      this.slides.forEach((slide) => slide.classList.add('swiper-slide'));
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      this.swiperInstance = new window.Swiper(this.container, {
        modules: [window.SwiperModules.Navigation],
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 2,
        grabCursor: true,
        navigation: {
          prevEl: this.prevEl,
          nextEl: this.nextEl,
        },
        on: {
          afterInit: (swiper) => {
            this.isLocked = swiper.isLocked;
            this.buttonGroup?.classList.toggle('hidden', swiper.isLocked);
          },
        },
      });
    }

    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (this.isSwiperEnabled) {
          this.enableSwiper(); // smart reinit
        }
      }, 200);
    }
  }

  customElements.define('row-teaser', RowTeaser);
}
